
export const FormListMeta = {
  label: 'name',
};
